/**
 * @fileoverview POST handler for the "/apps/business/account_fields" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsBusinessAccountFieldsCacheKeys } from "./constants";
import type { PostAppsBusinessAccountFieldsProps, AppsBusinessAccountFieldsResult } from "./types";

export const postAppsBusinessAccountFields = reactQueryMutationAdapter(
  appsBusinessAccountFieldsCacheKeys,
  (props: PostAppsBusinessAccountFieldsProps): Promise<AppsBusinessAccountFieldsResult> => {
    return fetch("/apps/business/account_fields", "POST", props, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
